const getStepFromData = (values) => {
    const maxAbs = Math.max(...values.map((v) => Math.abs(v)));
    const magnitude = 10 ** Math.floor(Math.log10(maxAbs));
    return magnitude;
};
const roundDownToAutoStep = (value, values) => {
    const step = getStepFromData(values);
    return Math.floor(value / step) * step;
};
export const getMinValue = (data) => {
    if (!data || data.length === 0) {
        return 0;
    }
    const allValues = [];
    for (const series of data) {
        for (const point of series.data) {
            allValues.push(point.value);
        }
    }
    if (allValues.length === 0) {
        return 0;
    }
    let minValue = 0;
    for (const value of allValues) {
        if (value < minValue) {
            minValue = value;
        }
    }
    return roundDownToAutoStep(minValue, allValues);
};
